import { render, staticRenderFns } from "./CustomOptionSelector.vue?vue&type=template&id=087da91a&scoped=true&"
import script from "./CustomOptionSelector.vue?vue&type=script&lang=js&"
export * from "./CustomOptionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087da91a",
  null
  
)

export default component.exports